import { useEffect } from 'react';
import { getAccessToken } from '../components/accesstoken';
import { config } from '../config';

const BACKEND_URL = config.VITE_GRAPHQL_URL || 'https://backapp.hubert.ai';

export const postStats = (stats: object) => {
  const at = getAccessToken();
  fetch(`${BACKEND_URL}/stats`, {
    method: 'POST',
    headers: { 'content-type': 'application/json', ...(at && { authorization: `Bearer ${at}` }) },
    body: JSON.stringify({
      location: document.location.href,
      referrer: document.referrer,
      ...stats,
    }),
  }).catch(() => console.warn('Failed to post stats', stats));
};

export const useStats = (stats: object, deps?: React.DependencyList) => useEffect(() => postStats(stats), deps);
